import { render } from "./EditModal.vue?vue&type=template&id=1519764b&ts=true"
import script from "./EditModal.vue?vue&type=script&lang=ts"
export * from "./EditModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__